import React from 'react';

const Line = () => <hr className="bg-muted w-100" />;

export default Line;